import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-multirisque-immeuble-pro',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-multirisque-immeuble-pro.component.html',
  styleUrls: ['./assurance-multirisque-immeuble-pro.component.scss']
})
export class AssuranceMultirisqueImmeubleProComponent {
  title = 'Assurance Multirisque Immeuble - MRI - PNE';
  subtitle = '';
  heroImage = 'assets/static_pages_images/MultirisqueImmeuble-PNO.jpg';

  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Multirisque Immeuble', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Multirisque Professionnelle',
    link: '/assurance-multirisque-pro'
  };

  nextPage = { 
    title: 'Assurance Bris de Machine',
    link: '/assurance-bris-machine'
  };
}
